import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import ListPage from "@/pages/ListPage";
import EntityPage from "@/pages/EntityPage";
import SearchPage from "@/pages/SearchPage";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/knowledge">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ListPage kind="services" />} />
          <Route path="/companies" element={<ListPage kind="companies" />} />
          <Route path="/categories" element={<ListPage kind="categories" />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/service/:slug" element={<EntityPage type="service" />} />
          <Route path="/company/:slug" element={<EntityPage type="company" />} />
          <Route path="/category/:slug" element={<EntityPage type="category" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
